export default "__VITE_ASSET__q1sk1H$9__"